import serialize from "json-form-data";
import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';
import { param } from "@/utils/url/param";
import { getApi } from "./utils";

import medicalDocuments from "./personal-employee/medical-documents";
import transactions from "./personal-employee/transactions";

const api_url = "/index.php";

export default {
    namespaced: true,

    state: {
        postsList: [],
        personalParams: {},
        userInfo: {},
        userColumns: [],
        totalItemsCount: 0,
        totalPages: 1,
        totalItemsCountAccountable: 0,
        totalPagesAccountable: 1,
        moveInCompanyTableColumns: [
            {
                id: "description",
                label: "Изменение",
                fullName: "Изменение",
                type: "string",
                level: 0,
                width: "52%",
                colspan: 1,
                characteristic: "",
            },
            {
                id: "date",
                label: "Дата изменения",
                fullName: "Дата изменения",
                type: "date",
                width: "16%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "author",
                label: "Автор изменения",
                fullName: "Автор изменения",
                type: "string",
                width: "32%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
        ],
        mainFactorsTableColumns: [
            {
                id: "change",
                label: "Смена",
                fullName: "Смена",
                type: "string",
                level: 0,
                colspan: 2,
                characteristic: "",
            },
            {
                id: "placeOfWork",
                label: "Место работы",
                fullName: "Место работы",
                type: "string",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "total",
                label: "Всего, ฿",
                fullName: "Всего, ฿",
                type: "number",
                colspan: 1,
                level: 0,
                characteristic: "",
            },
            {
                id: "mainPartSalary",
                label: "Основная часть ЗП, ฿",
                fullName: "Основная часть ЗП, ฿",
                type: "number",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "variablePartSalary",
                label: "Перемен. часть ЗП, ฿",
                fullName: "Переменная часть ЗП, ฿",
                type: "number",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "depreciation",
                label: "Депрем., ฿",
                fullName: "Депремирование, ฿",
                type: "number",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "rewardsShift",
                label: "Поощр-й за смену, ฿",
                fullName: "Поощрений за смену, ฿",
                type: "string",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "finesPerShift",
                label: "Штрафов за смену, ฿",
                fullName: "Штрафов за смену, ฿",
                type: "string",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
        ],
        financePersonalAccountColumnsTable: [
            {
                id: "amount",
                label: "Событие, ฿",
                fullName: "Изменение",
                type: "string",
                level: 0,
                width: "11%",
                colspan: 1,
                characteristic: "",
            },
            {
                id: "date_created",
                label: "Дата",
                fullName: "Дата",
                type: "date",
                width: "10%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "operation_author",
                label: "Кто внес/снял",
                fullName: "Кто внес/снял",
                type: "string",
                width: "30%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "title",
                label: "Причина",
                fullName: "Причина",
                type: "string",
                width: "50%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
        ],
        financeDepositColumnsTable: [
            {
                id: "amount",
                label: "Событие, ฿",
                fullName: "Изменение",
                type: "string",
                level: 0,
                width: "17%",
                colspan: 1,
                characteristic: "",
            },
            {
                id: "date_create",
                label: "Дата",
                fullName: "Дата",
                type: "date",
                width: "16%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "operation_author",
                label: "Кто внес/снял",
                fullName: "Кто внес/снял",
                type: "string",
                width: "46%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "balance",
                label: "Баланс, ฿",
                fullName: "Баланс, ฿",
                type: "string",
                width: "17%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
        ],
        referralsBroughtEmployeesTableColumns: [
            {
                id: "name",
                label: "ФИО",
                fullName: "ФИО",
                type: "string",
                level: 0,
                width: "29.5%",
                colspan: 1,
                characteristic: "",
            },
            {
                id: "post",
                label: "Текущие должности и разряды",
                fullName: "Текущие должности и разряды",
                type: "string",
                width: "28%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "filial",
                label: "Филиал",
                fullName: "Филиал",
                type: "string",
                width: "10%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "worksheet_date",
                label: "Анкета заполнена",
                fullName: "Анкета заполнена",
                type: "string",
                width: "13%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "hired_date",
                label: "Принят на работу",
                fullName: "Принят на работу",
                type: "string",
                width: "12.5%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "bonus",
                label: "Бонусы",
                fullName: "Бонусы",
                type: "number",
                width: "7%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
        ],
        refferalsHistoryBonusesTableColumns: [
            {
                id: "date",
                label: "Дата операции",
                fullName: "Дата операции",
                type: "date",
                level: 0,
                width: "11%",
                colspan: 1,
                characteristic: "",
            },
            {
                id: "accruedWrittenOff",
                label: "Начилено/списано",
                fullName: "Начилено/списано",
                type: "number",
                width: "13.5%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "name",
                label: "Привед-й сотрудник",
                fullName: "Приведенный сотрудник",
                type: "string",
                width: "33%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "description",
                label: "Основание транз-и",
                fullName: "Основание транзакции",
                type: "string",
                width: "42.5%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
        ],
        documentsTableColumns: [
            {
                id: "doc_type",
                label: "Документ",
                fullName: "Документ",
                type: "string",
                level: 0,
                width: "57%",
                colspan: 1,
                characteristic: "",
            },
            {
                id: "deadline",
                label: "Срок годности",
                fullName: "Срок годности",
                type: "date",
                width: "13%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "files",
                label: "Файлы",
                fullName: "Файлы",
                type: "string",
                width: "10%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "created",
                label: "Добавлен",
                fullName: "Добавлен",
                type: "date",
                width: "10%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
        ],
        disciplineTableColumns: [
            {
                id: "filial",
                label: "Филиал",
                fullName: "Филиал",
                type: "string",
                level: 0,
                width: "8.5%",
                colspan: 1,
                characteristic: "",
            },
            {
                id: "date_timestamp",
                label: "Дата",
                fullName: "Дата",
                type: "date",
                width: "7%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "is",
                label: "Мера",
                fullName: "Мера",
                type: "string",
                width: "8%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "reason",
                label: "Причина",
                fullName: "Причина",
                type: "string",
                width: "32%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "summ",
                label: "Сумма/баллы",
                fullName: "Сумма/баллы",
                type: "string",
                width: "6.5%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "user",
                label: "Выписал",
                fullName: "Выписал",
                type: "string",
                width: "19%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "deadline_timestamp",
                label: "Ответ к дате",
                fullName: "Ответ к дате",
                type: "date",
                width: "9%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
            {
                id: "explanatory",
                label: "Объясн-я",
                fullName: "Объяснительная",
                type: "string",
                width: "10%",
                level: 0,
                colspan: 1,
                characteristic: "",
            },
        ],

        collections: {
            transactionMethodsList: [],
            moneySourceList: [],
        }
    },

    mutations: {
        setUserInfo(state, info) {
            state.userInfo = info;
        },
        setUserColumns(state, userColumns) {
            state.userColumns = userColumns;
        },
        setTotalItemsCount(state, amount) {
            state.totalItemsCount = amount;
        },
        setTotalPages(state, amount) {
            state.totalPages = amount;
        },
        setTotalItemsCountAccountable(state, amount) {
            state.totalItemsCountAccountable = amount;
        },
        setTotalPagesAccountable(state, amount) {
            state.totalPagesAccountable = amount;
        },
        setPersonalParams(state, personalParams) {
            state.personalParams = personalParams;
        },
        setTransactionMethodsList(state, transactionMethodsList) {
            state.collections.transactionMethodsList = transactionMethodsList;
        },
        setMoneySourceList(state, moneySourceList) {
            state.collections.moneySourceList = moneySourceList;
        },
        setPostsList(state, postsList) {
            state.postsList = postsList;
        },
    },

    getters: {
        getTableColumnsMoveInCompany(state) {
            return state.moveInCompanyTableColumns;
        },
        getTableColumnsMainFactors(state) {
            return state.mainFactorsTableColumns;
        },
        getTableColumnsFinancePersonalAccount(state) {
            return state.financePersonalAccountColumnsTable;
        },
        getTableColumnsFinanceDeposit(state) {
            return state.financeDepositColumnsTable;
        },
        getTableColumnsRefferalsBroughtEmployees(state) {
            return state.referralsBroughtEmployeesTableColumns;
        },
        getTableColumnsRefferalsHistoryBonuses(state) {
            return state.refferalsHistoryBonusesTableColumns;
        },
        getTableColumnsDocuments(state) {
            return state.documentsTableColumns;
        },
        getTableColumnsDiscipline(state) {
            return state.disciplineTableColumns;
        },
        getUserPosition(state) {
            const [position] = Object.values(state.userInfo.posts);
            return position.split("/")[0].trim();
        },
    },

    actions: {
        async getUserInfo({ commit, rootState }, workerId) {
            const token = rootState.authToken;
            const { userId } = rootState;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/info&user_id=${userId}&worker_id=${workerId}`, token),
            );

            const json = await res.json();

            if (json && json.response) {
                commit("setUserInfo", json.response);

                return json;
            }
        },
        async getPermissionsTabs({ commit, rootState }) {
            const token = rootState.authToken;
            const { userId } = rootState;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/permissions/filials-personal-worker&user_id=${userId}`, token),
            );

            const json = await res.json();


            return json;
        },
        async getDataWorkerMoveInCompany(ctx, params) {
            const token = ctx.rootState.authToken;
            const workerId = params.userId;
            const sortBy = params.sortBy === "date" ? "date_time" : params.sortBy;
            const { sortType } = params;
            const periodStart = params.periodStart ? params.periodStart : "";
            const periodEnd = params.periodEnd ? params.periodEnd : "";

            const form_data = new FormData();

            if (periodStart.length > 0 && periodEnd.length > 0) {
                form_data.append("params[start]", periodStart);
                form_data.append("params[finish]", periodEnd);
            }

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/history&worker_id=${workerId}&sort_type=${sortType}&sort_by=${sortBy}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },
        async getDataWorkerMainFactors(ctx, params) {
            const workerId = params.userId;
            const periodStart = params.periodStart ? params.periodStart : "";
            const periodEnd = params.periodEnd ? params.periodEnd : "";
            const filial = params.filial ? params.filial : null;
            const dataType = params.dataType ? params.dataType : "";
            const token = ctx.rootState.authToken;

            const form_data = new FormData();

            if (periodStart.length > 0 && periodEnd.length > 0) {
                form_data.append("params[start]", periodStart);
                form_data.append("params[finish]", periodEnd);
            }

            if (filial !== null) {
                form_data.append("params[filial_id]", filial);
            }

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/general-indicators&worker_id=${workerId}&data_type=${dataType}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },

        async getColumnsTransactionsPersonalAccount(ctx, forDelete) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/columns&for_delete=${forDelete}`, token));
            const json = await res.json();
            
            return json;
        },

        async getColumnsTransactionsAccountable(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/accountable-history/columns`, token));
            const json = await res.json();
            
            return json;
        },

        async getColumnsAllTransactions(ctx, forDelete) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/finance-transaction/columns&for_delete=${forDelete}`, token));
            const json = await res.json();
            
            return json;
        },

        async getWorkerAmount(ctx, workerId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/amount&worker_id=${workerId}`, token));
            const json = await res.json();
            
            return json;
        },

        async getWorkerSummary({ rootState, commit }, params) {
            const workerId = params.userId;
            const { sort, deleted } = params;
            const periodStart = params.periodStart ? params.periodStart : "";
            const periodEnd = params.periodEnd ? params.periodEnd : "";
            const filters = params.filters;
            const token = rootState.authToken;

            const filial = params.filial ? params.filial : "";

            const form_data = new FormData();

            if (filters && filters.columnFilters) {
                for (let filterName in filters.columnFilters) {
                    if (filterName !== "date") form_data.append(`params[${filterName}_search_type]`, filters.columnFilters[filterName].searchType);
    
                    if (filters.columnFilters[filterName].type === "date" && filters.columnFilters[filterName].searchType === "range" && filterName === "date") {
                        form_data.append("params[date_user_search_type]", "range");
                        form_data.append(`params[date_user_value]`, filters.columnFilters[filterName].value[0].split("-")[0]);
                        form_data.append(`params[date_user_value_end]`, filters.columnFilters[filterName].value[0].split("-")[1]);
                    } else if (filters.columnFilters[filterName].type === "date" && filters.columnFilters[filterName].searchType === "range") {
                        form_data.append(`params[${filterName}_value]`, filters.columnFilters[filterName].value[0]);
                        form_data.append(`params[${filterName}_value_end]`, filters.columnFilters[filterName].value[1]);
                    } else if (filters.columnFilters[filterName].type === "number" && filters.columnFilters[filterName].searchType === "4") {
                        form_data.append(`params[${filterName}_value]`, filters.columnFilters[filterName].value.start);
                        form_data.append(`params[${filterName}_value_end]`, filters.columnFilters[filterName].value.end);
                    } else {
                        form_data.append(`params[${filterName}_value]`, filters.columnFilters[filterName].value);
                    }
                }
            }

            if (filters && filters.globalFilters) {
                for (let filterName in filters.globalFilters) {
                    if (filterName !== "global_date") form_data.append(`params[${filterName}_search_type]`, filters.globalFilters[filterName].searchType);
    
                    if (filterName === "global_date") {
                        form_data.append("params[global_date_user_search_type]", "range");
                        form_data.append(`params[global_date_user_value]`, filters.globalFilters[filterName].value[0].split("-")[0]);
                        form_data.append(`params[global_date_user_value_end]`, filters.globalFilters[filterName].value[0].split("-")[1]);
                    } else if (filters.globalFilters[filterName].type === "date" && filters.globalFilters[filterName].searchType === "range") {
                        form_data.append(`params[${filterName}_value]`, filters.globalFilters[filterName].value[0]);
                        form_data.append(`params[${filterName}_value_end]`, filters.globalFilters[filterName].value[1]);
                    } else if (filters.globalFilters[filterName].type === "number" && filters.globalFilters[filterName].searchType === "4") {
                        form_data.append(`params[${filterName}_value]`, filters.globalFilters[filterName].value.start);
                        form_data.append(`params[${filterName}_value_end]`, filters.globalFilters[filterName].value.end);
                    } else {
                        form_data.append(`params[${filterName}_value]`, filters.globalFilters[filterName].value);
                    }
                }
            }

            if (periodStart.length > 0 && periodEnd.length > 0) {
                form_data.append("params[date_user_search_type]", "range");
                form_data.append("params[date_user_value]", periodStart);
                form_data.append("params[date_user_value_end]", periodEnd);
            }

            form_data.append("params[sort]", sort);

            const url = addAuthKey(`${api_url}/?r=api/worker-profile/summary-finance-operations&worker_id=${workerId}&is_delete=${deleted ? 1 : 0}`, token);

            const { data } = await axios.post(url, form_data);

            return data;
        },

        async getListTransactionsPersonalAccount({ rootState, commit }, params) {
            const workerId = params.userId;
            const { sort, deleted } = params;
            const periodStart = params.periodStart ? params.periodStart : "";
            const periodEnd = params.periodEnd ? params.periodEnd : "";
            const page = params.page;
            const filters = params.filters;
            const token = rootState.authToken;

            const form_data = new FormData();

            if (filters && filters.columnFilters) {
                for (let filterName in filters.columnFilters) {
                    if (filterName !== "date") form_data.append(`params[${filterName}_search_type]`, filters.columnFilters[filterName].searchType);
    
                    if (filters.columnFilters[filterName].type === "date" && filters.columnFilters[filterName].searchType === "range" && filterName === "date") {
                        form_data.append("params[date_user_search_type]", "range");
                        form_data.append(`params[date_user_value]`, filters.columnFilters[filterName].value[0].split("-")[0]);
                        form_data.append(`params[date_user_value_end]`, filters.columnFilters[filterName].value[0].split("-")[1]);
                    } else if (filters.columnFilters[filterName].type === "date" && filters.columnFilters[filterName].searchType === "range") {
                        form_data.append(`params[${filterName}_value]`, filters.columnFilters[filterName].value[0]);
                        form_data.append(`params[${filterName}_value_end]`, filters.columnFilters[filterName].value[1]);
                    } else if (filters.columnFilters[filterName].type === "number" && filters.columnFilters[filterName].searchType === "4") {
                        form_data.append(`params[${filterName}_value]`, filters.columnFilters[filterName].value.start);
                        form_data.append(`params[${filterName}_value_end]`, filters.columnFilters[filterName].value.end);
                    } else {
                        form_data.append(`params[${filterName}_value]`, filters.columnFilters[filterName].value);
                    }
                }
            }

            if (filters && filters.globalFilters) {
                for (let filterName in filters.globalFilters) {
                    if (filterName !== "global_date") form_data.append(`params[${filterName}_search_type]`, filters.globalFilters[filterName].searchType);
    
                    if (filterName === "global_date") {
                        form_data.append("params[global_date_user_search_type]", "range");
                        form_data.append(`params[global_date_user_value]`, filters.globalFilters[filterName].value[0].split("-")[0]);
                        form_data.append(`params[global_date_user_value_end]`, filters.globalFilters[filterName].value[0].split("-")[1]);
                    } else if (filters.globalFilters[filterName].type === "date" && filters.globalFilters[filterName].searchType === "range") {
                        form_data.append(`params[${filterName}_value]`, filters.globalFilters[filterName].value[0]);
                        form_data.append(`params[${filterName}_value_end]`, filters.globalFilters[filterName].value[1]);
                    } else if (filters.globalFilters[filterName].type === "number" && filters.globalFilters[filterName].searchType === "4") {
                        form_data.append(`params[${filterName}_value]`, filters.globalFilters[filterName].value.start);
                        form_data.append(`params[${filterName}_value_end]`, filters.globalFilters[filterName].value.end);
                    } else {
                        form_data.append(`params[${filterName}_value]`, filters.globalFilters[filterName].value);
                    }
                }
            }

            console.log('periodStart', params)
            // if (periodStart.length > 0 && periodEnd.length > 0) {
            //     form_data.append("params[date_user_search_type]", "range");
            //     form_data.append("params[date_user_value]", periodStart);
            //     form_data.append("params[date_user_value_end]", periodEnd);
            // }

            form_data.append("params[sort]", sort);

            const url = addAuthKey(`${api_url}/?r=api/worker-profile/finance-operations&worker_id=${workerId}&page=${page}&is_delete=${deleted ? 1 : 0}`, token);

            const { data, headers } = await axios.post(url, form_data);

            commit("setTotalItemsCount", +headers["x-pagination-total-count"]);
            commit("setTotalPages", +headers["x-pagination-page-count"]);

            return data;
        },

        async getListAllTransactions({ rootState, commit }, params) {
            const { sort, deleted } = params;
            const periodStart = params.periodStart ? params.periodStart : "";
            const periodEnd = params.periodEnd ? params.periodEnd : "";
            const page = params.page;
            const filters = params.filters;
            const type = params.type;
            const token = rootState.authToken;

            const form_data = new FormData();

            if (filters && filters.columnFilters) {
                for (let filterName in filters.columnFilters) {
                    if (filters.columnFilters[filterName].value) {
                        form_data.append(`params[${filterName}_search_type]`, filters.columnFilters[filterName].searchType);
    
                        if (filters.columnFilters[filterName].type === "date" && filters.columnFilters[filterName].searchType === "range") {
                            form_data.append(`params[${filterName}_value]`, filters.columnFilters[filterName].value[0]);
                            form_data.append(`params[${filterName}_value_end]`, filters.columnFilters[filterName].value[1]);
                        } else if (filters.columnFilters[filterName].type === "number" && filters.columnFilters[filterName].searchType === "4") {
                            form_data.append(`params[${filterName}_value]`, filters.columnFilters[filterName].value.start);
                            form_data.append(`params[${filterName}_value_end]`, filters.columnFilters[filterName].value.end);
                        } else {
                            form_data.append(`params[${filterName}_value]`, filters.columnFilters[filterName].value);
                        }
                    }
                }
            }

            if (filters && filters.globalFilters) {
                for (let filterName in filters.globalFilters) {
                    form_data.append(`params[${filterName}_search_type]`, filters.globalFilters[filterName].searchType);
    
                    if (filters.globalFilters[filterName].type === "date" && filters.globalFilters[filterName].searchType === "range") {
                        form_data.append(`params[${filterName}_value]`, filters.globalFilters[filterName].value[0]);
                        form_data.append(`params[${filterName}_value_end]`, filters.globalFilters[filterName].value[1]);
                    } else if (filters.globalFilters[filterName].type === "number" && filters.globalFilters[filterName].searchType === "4") {
                        form_data.append(`params[${filterName}_value]`, filters.globalFilters[filterName].value.start);
                        form_data.append(`params[${filterName}_value_end]`, filters.globalFilters[filterName].value.end);
                    } else {
                        form_data.append(`params[${filterName}_value]`, filters.globalFilters[filterName].value);
                    }
                }
            }

            if (periodStart.length > 0 && periodEnd.length > 0) {
                form_data.append("params[date_user_search_type]", "range");
                form_data.append("params[date_user_value]", periodStart);
                form_data.append("params[date_user_value_end]", periodEnd);
            }

            if (type) {
                form_data.append("params[type_search_type]", "1");
                form_data.append("params[type_value]", type);
            }

            form_data.append("params[sort]", sort);

            const url = addAuthKey(`${api_url}/?r=api/finance-transaction/index&page=${page}&is_delete=${deleted ? 1 : 0}`, token);

            const { data, headers } = await axios.post(url, form_data);

            commit("setTotalItemsCount", +headers["x-pagination-total-count"]);
            commit("setTotalPages", +headers["x-pagination-page-count"]);

            return data;
        },

        async getListTransactionsPersonalAccountForPrint({ rootState, commit }, params) {
            const { workerId, deleted } = params;
            const token = rootState.authToken;
            const form_data = new FormData();

            form_data.append("params[is_export]", 1);

            for (let filterName in params) {
                if (filterName !== "workerId" && filterName !== "deleted" && filterName !== "print") {
                    if (filterName === "sort") {
                        form_data.append(`params[${filterName}]`, `-${params[filterName]}`);
                    } else {
                        form_data.append(`params[${filterName}]`, params[filterName]);
                    }
                }
            }

            if (!params.date_user_value_end) {
                form_data.append(`params[date_user_value_end]`, params.date_user_value);
            }

            const url = addAuthKey(`${api_url}/?r=api/worker-profile/finance-operations&worker_id=${workerId}&is_delete=${deleted ? 0 : 1}`, token);

            const { data } = await axios.post(url, form_data);
            
            return data;
        },

        async fetchUserColumns({ rootState, commit }) {
            const token = rootState.authToken;
            const { userId } = rootState;
            const url = addAuthKey(`${api_url}?r=api/worker-profile/user-columns&user_id=${userId}`, token);
    
            const { data } = await axios.get(url);
            commit("setUserColumns", data.columns);
        },

        async fetchUserColumnsAll({ rootState, commit }) {
            const token = rootState.authToken;
            const { userId } = rootState;
            const url = addAuthKey(`${api_url}?r=api/finance-transaction/user-columns&user_id=${userId}`, token);

            const { data } = await axios.get(url);
            commit("setUserColumns", data.columns);
        },

        async fetchAllUserColumns({ rootState, commit }) {
            const token = rootState.authToken;
            const { userId } = rootState;
            const url = addAuthKey(`${api_url}?r=api/finance-transaction/user-columns&user_id=${userId}`, token);
    
            const { data } = await axios.get(url);
            commit("setUserColumns", data.columns);
        },

        async saveUserColumns({ commit, rootState }, columns) {
            const token = rootState.authToken;
            const { userId } = rootState;
            const formData = new FormData();
    
            formData.append("columns", JSON.stringify(columns));
            formData.append("user_id", userId);
    
            const url = addAuthKey(`${api_url}?r=api/worker-profile/save-user-columns`, token);
    
            await axios.post(url, formData);
            commit("setUserColumns", columns);
        },

        async saveUserColumnsAll({ commit, rootState }, columns) {
            const token = rootState.authToken;
            const { userId } = rootState;
            const formData = new FormData();
    
            formData.append("columns", JSON.stringify(columns));
            formData.append("user_id", userId);
    
            const url = addAuthKey(`${api_url}?r=api/finance-transaction/save-user-columns`, token);
    
            await axios.post(url, formData);
            commit("setUserColumns", columns);
        },

        async removeTransaction({ rootState }, params) {
            const { authToken: token } = rootState;
            const { id, comment } = params;

            const url = addAuthKey(`${api_url}/?r=api/worker-profile/finance-item-status&id=${id}&delete=1`, token);

            const { data } = await axios.post(url, {
                comment,
            });

            return data;
        },

        async removeTransactionAll({ rootState }, params) {
            const { authToken: token } = rootState;
            const { id, comment } = params;

            const url = addAuthKey(`${api_url}/?r=api/finance-transaction/finance-item-status&id=${id}&delete=1`, token);

            const { data } = await axios.post(url, {
                comment,
            });

            return data;
        },

        async restoreTransaction({ rootState }, id) {
            const { authToken: token } = rootState;

            const url = addAuthKey(`${api_url}/?r=api/worker-profile/finance-item-status&id=${id}&delete=0`, token);

            const { data } = await axios.get(url);

            return data;
        },

        async restoreTransactionAll({ rootState }, id) {
            const { authToken: token } = rootState;

            const url = addAuthKey(`${api_url}/?r=api/finance-transaction/finance-item-status&id=${id}&delete=0`, token);

            const { data } = await axios.get(url);

            return data;
        },

        async getListTransactionsDeposit(ctx, params) {
            const token = ctx.rootState.authToken;
            const workerId = params.userId;
            const { sortType } = params;
            const { sortBy } = params;
            const periodStart = params.periodStart ? params.periodStart : "";
            const periodEnd = params.periodEnd ? params.periodEnd : "";

            const form_data = new FormData();

            if (periodStart.length > 0 && periodEnd.length > 0) {
                form_data.append("params[start]", periodStart);
                form_data.append("params[finish]", periodEnd);
            }

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/deposit&worker_id=${workerId}&sort_by=${sortBy}&sort_type=${sortType}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },

        async getListTransactionsAccountable({ commit, rootState }, params) {
            const token = rootState.authToken;
            const { workerId, sort, page, filters } = params; 
            const periodStart = params.periodStart ? params.periodStart : "";
            const periodEnd = params.periodEnd ? params.periodEnd : "";
            
            const form_data = new FormData();

            let dateIsAdded = false;

            if (filters) {
                for (let filterName in filters) {
                    if (filters[filterName].id === "date" && filters[filterName].searchType === "range" && !dateIsAdded) {
                        form_data.append(`params[${filters[filterName].id}_search_type]`, "range");
                        form_data.append(`params[${filters[filterName].id}_value]`, filters[filterName].value.split(',')[0]);
                        form_data.append(`params[${filters[filterName].id}_value_end]`, filters[filterName].value.split(',')[1]);
                        dateIsAdded = true;
                    } else if (filters[filterName].type === "number" && filters[filterName].searchType === "4") {
                        form_data.append(`params[${filters[filterName].id}_search_type]`, filters[filterName].searchType);
                        form_data.append(`params[${filters[filterName].id}_value]`, filters[filterName].value.start);
                        form_data.append(`params[${filters[filterName].id}_value_end]`, filters[filterName].value.end);
                    } else {
                        if (filters[filterName].id === "date" && !dateIsAdded || filters[filterName].id !== "date") {
                            form_data.append(`params[${filters[filterName].id}_search_type]`, filters[filterName].searchType);
                            form_data.append(`params[${filters[filterName].id}_value]`, filters[filterName].value);
                            dateIsAdded = true;
                        }
                    }
                }
            }

            if (periodStart.length > 0 && periodEnd.length > 0) {
                form_data.append("params[global_date_search_type]", "range");
                form_data.append("params[global_date_value]", periodStart);
                form_data.append("params[global_date_value_end]", periodEnd);
            }

            form_data.append("params[sort]", sort);

            const url = addAuthKey(`${api_url}/?r=api/accountable-history/list&worker_id=${workerId}&page=${page}`, token);

            const { data, headers } = await axios.post(url, form_data);

            commit("setTotalItemsCountAccountable", +headers["x-pagination-total-count"]);
            commit("setTotalPagesAccountable", +headers["x-pagination-page-count"]);

            return data;
        },

        async getWorkersList(ctx, currentUserId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/workers-list&user_id=${currentUserId}`, token));

            const json = await res.json();

            return json;
        },

        async getNewWorkersList(ctx) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(`${api_url}?r=api/worker/list-with-photo`, token));

            const json = await res.json();

            return json;
        },

        async getWorkerComment(ctx, id) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/comment&worker_id=${id}`, token));
            return res.json();
        },

        async saveWorkersComment(ctx, { id, comment }) {
            const token = ctx.rootState.authToken;
            const formData = new FormData();
            formData.append("comment", comment);

            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/save-comment&worker_id=${id}`, token), {
                method: "POST",
                body: formData,
            });
            return res.json();
        },

        async getReasonsListForTransactionPersonalAccountModal(ctx) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/reasons-list`, token));

            const json = await res.json();

            return json;
        },

        async getFilialsListForTransactionPersonalAccountModal(ctx) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/filial/index&acc`, token));

            const json = await res.json();

            return json;
        },

        async deleteTransactionPersonalAccount(ctx, params) {
            const { id } = params;
            const form_data = new FormData();
            const token = ctx.rootState.authToken;
            form_data.append("params[id]", id);

            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/remove-account-transaction`, token), {
                method: "post",
                body: form_data,
            });

            const json = await res.json();

            return json;
        },

        async executeTransactionPersonalAccount(ctx, params) {
            const { userId } = ctx.rootState;
            const { workerId } = params;
            const { workerIdWhoContributed } = params;
            const { operationType } = params;
            const { filialId } = params;
            const { reasonId } = params;
            const { newReasonText } = params;
            const { amount } = params;
            const { date } = params;
            const { comment } = params;
            const { authorIsUser } = params;
            const token = ctx.rootState.authToken;

            const form_data = new FormData();

            if (reasonId === -1) {
                form_data.append("params[reason_id]", newReasonText);
            } else {
                form_data.append("params[reason_id]", reasonId);
            }
            form_data.append("params[filial_id]", filialId);
            form_data.append("params[operation_type]", operationType);
            form_data.append("params[amount]", amount);
            form_data.append("params[date]", date);
            form_data.append("params[worker_id]", workerIdWhoContributed);
            form_data.append("params[author_is_user]", authorIsUser);

            if (comment.length > 0) form_data.append("params[comment]", comment);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/account-transaction&worker_id=${workerId}&user_id=${userId}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },

        async executeTransactionDeposit(ctx, params) {
            const { userId } = ctx.rootState;
            const { workerId } = params;
            const { workerIdWhoContributed } = params;
            const { operationType } = params;
            const { amount } = params;
            const { date } = params;
            const { comment } = params;
            const { usePersonalAccount } = params;
            const { authorIsUser } = params;
            const { filial_id } = params;
            const { post_code } = params;
            const { company_id } = params;
            const token = ctx.rootState.authToken;

            const form_data = new FormData();

            form_data.append("params[operation_type]", operationType);
            form_data.append("params[amount]", amount);
            form_data.append("params[date]", date);
            form_data.append("params[worker_id]", workerIdWhoContributed);
            form_data.append("params[use_personal_account]", usePersonalAccount);
            form_data.append("params[author_is_user]", authorIsUser);
            form_data.append("params[filial_id]", filial_id);
            form_data.append("params[post_code]", post_code);
            form_data.append("params[company_id]", company_id);

            if (comment.length > 0) form_data.append("params[comment]", comment);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/deposit-transaction&worker_id=${workerId}&user_id=${userId}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },

        async executeTransactionAccountableTransaction(ctx, params) {
            const { workerId } = params;
            const { workerIdWhoContributed } = params;
            const { operationType } = params;
            const { amount } = params;
            const { date } = params;
            const { comment } = params;
            const { usePersonalAccount } = params;
            const { filial_id } = params;
            const { post_code } = params;
            const { company_id } = params;
            const { money_source_id } = params;
            
            const token = ctx.rootState.authToken;

            const form_data = new FormData();

            form_data.append("params[type]", operationType === "add" ? "deposit" : "withdraw");
            if (workerIdWhoContributed !== null) form_data.append("params[author_worker_id]", workerIdWhoContributed);
            form_data.append("params[amount]", amount);
            form_data.append("params[use_personal_account]", usePersonalAccount);
            if (filial_id !== null) form_data.append("params[filial_id]", filial_id);
            if (post_code !== null) form_data.append("params[post_code]", post_code);
            if (company_id !== null) form_data.append("params[company_id]", company_id);
            if (money_source_id !== null) form_data.append("params[money_source_id]", money_source_id);
            form_data.append("params[date]", date);

            if (comment.length > 0) form_data.append("params[comment]", comment);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/accountable-history/create&worker_id=${workerId}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },

        async getWorkerInventoryItemsList(ctx, workerId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/inventory-worker/view&id=${workerId}`, token));

            const json = await res.json();

            return json;
        },

        async issueInventoryItemToEmployee(ctx, params) {
            const token = ctx.rootState.authToken;
            const data = {
                workerId: params.workerId,
                uniform_id: params.uniformId,
                date: params.dateIssue,
            };

            if (params.postCode) {
                data.post_code = params.postCode;
            }
            if (params.isUserIssued) {
                data.user_id = params.userId;
            } else {
                data.author_id = params.authorId;
            }

            if (params.serialNumber) {
                data.serial_number = params.serialNumber;
            }

            if (params.comment) {
                data.comment = params.comment;
            }

            const formData = serialize({
                params: data,
            });

            if (params.files) {
                params.files.forEach((file) => {
                    formData.append("files[]", file);
                });
            }

            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/give-uniform&worker_id=${params.workerId}`, token), {
                method: "post",
                body: formData,
            });

            const json = await res.json();

            return json;
        },

        async cancelIssueInventoryItemToEmployee(ctx, transactionId) {
            const { userId, authToken: token } = ctx.rootState;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/cancel-uniform&transaction_id=${transactionId}&user_id=${userId}`, token),
            );

            const json = await res.json();

            return json;
        },

        async uploadInventoryItemFiles(ctx, transaction) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/download-item-files&worker_uniform_id=${transaction}`, token),
            );

            const json = await res.json();

            return json;
        },

        async uploadInventoryHistoryFiles(ctx, transaction) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/download-item-files&u_history_id=${transaction}`, token));

            const json = await res.json();

            return json;
        },

        async getReferralsEmployeesList(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;
            const { userId } = params;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/invited-workers&worker_id=${workerId}&user_id=${userId}`, token),
            );

            const json = await res.json();

            return json;
        },

        async getReferralsHistoryBonusesList(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();

            const { workerId } = params;
            const { userId } = params;
            const { periodStart } = params;
            const { periodEnd } = params;

            if (periodStart.length > 0 && periodEnd.length > 0) {
                form_data.append("params[start]", periodStart);
                form_data.append("params[finish]", periodEnd);
            }

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/worker-bonuses&worker_id=${workerId}&user_id=${userId}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },

        async getPostList({ commit, rootState }) {
            const token = rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/posts-list`, token));

            const json = await res.json();

            commit("setPostsList", json.response);

            return json;
        },

        async getTypePostList({ rootState }) {
            const token = rootState.authToken;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/type-post/index`, token));

            const json = await res.json();

            return json;
        },

        async getTransactionTypeList({ rootState }) {
            const token = rootState.authToken;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/transaction-type/index`, token));

            const json = await res.json();

            return json;
        },

        async getMoneySourceList({ commit, rootState }) {
            const token = rootState.authToken;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/money-source/index`, token));

            const json = await res.json();

            commit("setMoneySourceList", json);

            return json;
        },
        
        async getTransactionMethodsList({ commit, rootState }) {
            const token = rootState.authToken;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/transaction-methods`, token));

            const json = await res.json();

            commit("setTransactionMethodsList", json);

            return json;
        },

        async saveBroughtEmployeeInfo(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;
            const { invitedById } = params;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/save-worker-invitation&worker_id=${workerId}&invited_by=${invitedById}`, token),
            );

            const json = await res.json();

            return json;
        },

        async convertBonusesInRub(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();

            const { workerId } = params;
            const { userId } = params;
            const { bonusValue } = params;
            const { realValue } = params;

            form_data.append("bonus_value", bonusValue);
            form_data.append("real_value", realValue);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/convert-bonuses&worker_id=${workerId}&user_id=${userId}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },

        async getListRequiredDocuments(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;
            const { isArchive } = params;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/required-documents&worker_id=${workerId}&is_archive=${isArchive}`, token));
            
            const json = await res.json();

            return json;
        },

        async getWorkerDocuments(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;
            const { isArchive } = params;
            const { sortBy } = params;
            const { sortType } = params;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/documents&worker_id=${workerId}&is_archive=${isArchive}&sort_by=${sortBy}&sort_type=${sortType}`, token),
            );

            const json = await res.json();

            return json;
        },

        async getDocumentHistory(ctx, documentId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/document-history&document_id=${documentId}`, token));

            const json = await res.json();

            return json;
        },

        async getDocumentsList(ctx, workerId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/documents-list&worker_id=${workerId}`, token));

            const json = await res.json();

            return json;
        },

        async moveDocumentToArchive(ctx, documentId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/move-doc-to-archive&document_id=${documentId}`, token));

            const json = await res.json();

            return json;
        },

        async addDocumentForWorker(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();

            const { workerId } = params;
            const { deadline } = params;
            const { comment } = params;
            const { typeDocId } = params;

            const fileList = params.files;

            form_data.append("params[type_doc_id]", typeDocId);
            form_data.append("params[deadline]", deadline);
            form_data.append("params[comment]", comment);

            for (let i = 0; i < fileList.length; i++) {
                const file = fileList[i];
                form_data.append(`files[${i}]`, file);
            }

            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/add-worker-document&worker_id=${workerId}`, token), {
                method: "post",
                body: form_data,
            });

            const json = await res.json();

            return json;
        },

        async editDocumentForWorker(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();

            const { deadline } = params;
            const { comment } = params;
            const { documentId } = params;
            const { typeDocId } = params;
            const { filesAddingDuringCreating } = params;

            const fileList = params.files;

            form_data.append("params[type_doc_id]", typeDocId);
            form_data.append("params[deadline]", deadline);
            form_data.append("params[comment]", comment);
            form_data.append("params[files]", JSON.stringify(filesAddingDuringCreating));

            for (let i = 0; i < fileList.length; i++) {
                const file = fileList[i];
                form_data.append(`files[${i}]`, file);
            }

            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/edit-worker-document&document_id=${documentId}`, token), {
                method: "post",
                body: form_data,
            });

            const json = await res.json();

            return json;
        },

        async getLinkOnDocumentsDownload(ctx, params) {
            const token = ctx.rootState.authToken;
            const { isArchive } = params;
            const { workerId } = params;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/download-files-archive&worker_id=${workerId}&is_archive=${isArchive}`, token),
            );

            const json = await res.json();

            return json;
        },

        async getLinkOnDocumentWorkerDownload(ctx, documentId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/download-document-files&document_id=${documentId}`, token),
            );

            const json = await res.json();

            return json;
        },

        async getInfoDisciplineForWorker(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();

            const { workerId } = params;
            const { sortBy } = params;
            const { sortType } = params;
            const { page } = params;

            const { periodStart } = params;
            const { periodEnd } = params;
            const { filialId } = params;
            const { disciplineType } = params;

            if (periodStart.length > 0 && periodEnd.length > 0) {
                form_data.append("params[start]", periodStart);
                form_data.append("params[finish]", periodEnd);
            }

            if (filialId !== undefined) form_data.append("params[filial_id]", filialId);
            if (disciplineType !== undefined) form_data.append("params[discipline_type]", disciplineType);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/discipline&worker_id=${workerId}&sort_by=${sortBy}&sort_type=${sortType}&page=${page}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },

        async writeExplanatory(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();

            const { penaltyId } = params;
            const { penaltyType } = params;
            const fileList = params.files;
            const { text } = params;

            form_data.append("params[text]", text);

            for (let i = 0; i < fileList.length; i++) {
                const file = fileList[i];
                form_data.append(`files[${i}]`, file);
            }

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/write-explanatory&penalty_id=${penaltyId}&penalty_type=${penaltyType}`, token),
                {
                    method: "post",
                    body: form_data,
                },
            );

            const json = await res.json();

            return json;
        },

        async showExplanatory(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;
            const { penaltyType } = params;
            const { penaltyId } = params;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/get-penalty-explanatory&worker_id=${workerId}&penalty_id=${penaltyId}&penalty_type=${penaltyType}`, token),
            );

            const json = await res.json();

            return json;
        },

        async getSummaryWorkerNotifications(ctx, workerId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/summary-notifications&worker_id=${workerId}`, token));

            const json = await res.json();

            return json;
        },

        async getCurrencyLabel(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/total-settings/currency-label`, token));

            const json = await res.json();

            console.log('json = ' + json.currency_label )

            return json.currency_label;
        },

        async getSummaryWorkerStatuses(ctx, workerId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/worker-summary-info&worker_id=${workerId}`, token));

            const json = await res.json();

            return json;
        },

        async editWorkerCharacteristic(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;
            const { characteristicId } = params;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/edit-worker-characteristic&worker_id=${workerId}&characteristic_id=${characteristicId}`, token),
            );

            const json = await res.json();

            return json;
        },

        async editWorkerEmploymentStatus(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;
            const { employmentStatusId } = params;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/edit-worker-employment-status&worker_id=${workerId}&employment_status_id=${employmentStatusId}`, token),
            );

            const json = await res.json();

            return json;
        },

        async getSummaryWorkerAccountInfo(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/summary-account-info&worker_id=${workerId}`, token));

            const json = await res.json();

            return json;
        },

        async getEmploymentStatuses(ctx, params) {
            const token = ctx.rootState.authToken;
            const withArchive = params && params.withArchive ? "yes" : "no";

            const res = await fetch(addAuthKey(`${api_url}/?r=api/catalogs/employment-statuses&with_archive=${withArchive}`, token));

            const json = await res.json();

            return json;
        },

        async getLegalEntities(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/companies/list&worker_id=${workerId}`, token),
            );
            const json = await res.json();
            return json;
        },

        async getAgreementTypes(ctx, params) {
            const token = ctx.rootState.authToken;
            const { workerId } = params;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/agreements/list&worker_id=${workerId}`, token));
            const json = await res.json();
            return json;
        },

        async getEmployeeAgreements(ctx, params) {
            const queryParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/worker-agreements/index",
                workerId: params.workerId,
            };

            if (params.periodStart) {
                queryParams.start = params.periodStart;
                queryParams.finish = params.periodEnd;
            }

            if (params.company) {
                queryParams.companies = [params.company];
            }

            if (params.types && params.types.length) {
                queryParams.agreement_types = params.types;
            }

            if (params.sortBy) {
                queryParams.sort = `${params.desc ? "-" : ""}${params.sortBy}`;
            }

            const query = param(queryParams);

            const res = await fetch(`${api_url}/?${query}`);

            const json = await res.json();

            return json;
        },
        async getUserProfile(ctx, id) {
            const { url} = getApi(ctx);
            const { data } = await axios.get(url("api/profile-value/worker-profile", { worker: 1, id }));

            return data;
        },
        async setUserProfile(ctx, id) {
            const { url } = getApi(ctx);

            const { data } = await axios.get(url("api/profile-value/set-profile", { id }));

            return data;
        },
        async getUserProfilePositions(ctx, id) {
            const { url } = getApi(ctx);

            const { data } = await axios.get(url("api/profile-value/post-select", { worker: 1, id }));

            return data;
        },
        async getUserProfileData(ctx, id) {
            const { url } = getApi(ctx);

            const { data } = await axios.get(url("api/profile-value/view", { worker: 1, id }));

            return data;
        },
        async saveUserProfileData(ctx, params) {
            const { url } = getApi(ctx);
            const { id, values, files } = params;

            const fd = serialize({ values });

            Object.entries(files).forEach(([key, value]) => {
                value.forEach((file) => {
                    fd.append(`files${key}[]`, file);
                });
            });

            const { data } = await axios.post(url("api/profile-value/save-values", { id, worker: 1 }), fd);

            return data;
        },
        async saveCustomProfileVariants(ctx, dictionaries) {
            const collection = {};

            if (!dictionaries.length) return collection;

            const { url } = getApi(ctx);

            const list = dictionaries.map((dictionary) => {
                const { fieldId, code, items } = dictionary;
                return code ? { code, values: items } : { field_id: fieldId, values: items };
            });

            const { data } = await axios.post(url("api/dictionary/multiple-save"), list);

            data.forEach((items) => {
                items.forEach((item) => {
                    const { profile_field_id, code, name, id } = item;
                    const dictionaryCode = code || profile_field_id;
                    if (!collection[dictionaryCode]) {
                        collection[dictionaryCode] = {};
                    }

                    collection[dictionaryCode][name] = id;
                });
            });

            return collection;
        },

        async moveToArchive(ctx, {ids}) {
            const { url } = getApi(ctx);

            try{
                const { data } = await axios.post(url("api/worker-profile/archive-doc"),
                    {document_ids: ids});

                return data;
            } catch(e) {
                console.log(e);
                return e;
            }

        },
    },

    modules: {
        medicalDocuments,
        transactions,
    },
};
